import React, {Component} from 'react';
import {connect} from 'react-redux';
import {TweenMax} from 'gsap/TweenMax';
import {TimelineMax} from 'gsap/TimelineMax';
import {Link} from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';


class Landing extends Component {
  state = {
    //fontSize: 20,
    fontSize: 80,
    count: 3,
  }

  componentDidMount() {
    this.thirdSizer();
    //this.sizer();
    //this.newSizer();
    //this.props.onCounterSize();
  }

  // sizer = () => {
  //   const myObj = {
  //     size: this.state.fontSize
  //   }
  //   TweenMax.to(myObj, 1, {size: 20, onUpdate: () => {
  //     this.setState({fontSize: myObj.size}, ()=>console.log(this.state.fontSize))
  //   }})
  //   this.changer();
  // }

  // changer = () => {
  //   this.props.onIncrementCounter()
  // }

  // newSizer = () => {
  //   const myObj = {
  //     size: this.state.fontSize
  //   }
  //   let tl = new TimelineMax();
  //   tl.to(myObj, 0.5, {size: 0, delay: 0.5, onUpdate: () => {
  //     this.setState({fontSize: myObj.size});
  //   }}).to(myObj, 0.5, {size: 20, onUpdate: () => {
  //     this.setState({fontSize: myObj.size});
  //   }}).eventCallback("onStart", this.changeCount()).to(myObj, 0.5, {size: 0, delay: 0.18, onUpdate: () => {
  //     this.setState({fontSize: myObj.size});
  //   }}).to(myObj, 0.5, {size: 20, onUpdate: () => {
  //     this.setState({fontSize: myObj.size});
  //   }}).eventCallback("onStart", this.changeCount()).to(myObj, 0.5, {size: 0, delay: 0.18, onUpdate: () => {
  //     this.setState({fontSize: myObj.size});
  //   }}).to(myObj, 0.5, {size: 20, onUpdate: () => {
  //     this.setState({fontSize: myObj.size});
  //   }}).eventCallback("onStart", this.changeCount());
  // }

  thirdSizer = () => {
    const aStyle = {
      fontFamily: 'Righteous',
      textDecoration: 'none',
      color: 'white'
    }
    const myObj = {
      size: this.state.fontSize
    }
    const tl = new TimelineMax({delay: 1});
    tl.add(TweenMax.to(myObj, 0.5,
      {
        size: 0,
        onUpdate: () => {
          this.setState({fontSize: myObj.size})
        }
      })
    )
    tl.add(TweenMax.to(myObj, 0.5,
      {
        //size: 20,
        size: 80,
        onUpdate: () => {
          this.setState({fontSize: myObj.size, count: 2})
        }
      })
    )
    tl.add(TweenMax.to(myObj, 0.5,
      {
        size: 0,
        delay: 0.5,
        onUpdate: () => {
          this.setState({fontSize: myObj.size})
        }
      })
    )
    tl.add(TweenMax.to(myObj, 0.5,
      {
        //size: 20,
        size: 80,
        onUpdate: () => {
          this.setState({fontSize: myObj.size, count: 1})
        }
      })
    )
    tl.add(TweenMax.to(myObj, 0.5,
      {
        size: 0,
        delay: 0.5,
        onUpdate: () => {
          this.setState({fontSize: myObj.size})
        }
      })
    )
    tl.add(TweenMax.to(myObj, 0.5,
      {
        //size: 10,
        size: 30,
        onUpdate: () => {
          this.setState({fontSize: myObj.size, count: <Link className={css(styles.aStyle)} to={`/portfolio`}>enter</Link>})
        }
      })
    )
  }

  changeCount = (obj) => {
      let count = this.state.count;
      count++;
      this.setState({count});
  }

  render() {
    const pStyle = {
      fontSize: this.state.fontSize //+ 'em'
    }
    return(
      // <div className={`container-fluid ${css(styles.landingStyle)}`}>
      //   <p style={pStyle} className={css(styles.pStyle)}>{this.state.count}</p>
      // </div>
      <div className={css(styles.div1)}>
          <div className={css(styles.div2)}>
              <div className={css(styles.div3)}>
                  <div className={css(styles.div4)}>
                      <div className={css(styles.div5)}>
                          <div className={css(styles.div6)}>
                            <p style={pStyle} className={css(styles.text)}>{this.state.count}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ctr: state.counter,
    counterSize: state.grow
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onIncrementCounter: () => dispatch({type: 'INCREMENT'}),
    onToEnter: () => dispatch({type: 'TO_ENTER'}),
    onCounterSize: () => dispatch({type: 'COUNTER_SIZE'})
  }
}

const styles = StyleSheet.create({
  aStyle: {
    color: "#4669F6",
    fontFamily: "'Stalinist One', cursive",
    fontWeight: 575,
    textDecoration: 'none',
    ':hover': {
      color: '#ff9c23'
    }
  },
  landingStyle: {
    background: '#2b2b2f',
    height: '100vh'
  },
  pStyle: {
    paddingTop: '20vh',
    fontFamily: 'Squada One',
    color: '#f5b779',
  },
  div1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: "100vw",
    minHeight: "100vh",
    backgroundColor: "#FFB300"
},
div2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    "@media (orientation: landscape)":{
        minWidth: "91%",
        minHeight: "100vh",
    },
    "@media (orientation: portrait)":{
        minWidth: "100%",
        minHeight: "91vh"
    },
    backgroundColor: "#FF5700",
},
div3: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: "0 auto",
    minWidth: "62%",
    minHeight: "62vh",
    backgroundColor: "#F23F11"
},
div4: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: "0 auto",
    minWidth: "62%",
    minHeight: "32vh",
    backgroundColor: "#DE0606",
},
div5: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: "0 auto",
    minWidth: "62%",
    minHeight: "24vh",
    backgroundColor: "hsla(352, 100%, 41%, .65)",
},
div6: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: "0 auto",
    minWidth: "62%",
    minHeight: "14vh",
    
    "@media (orientation: landscape)":{
      backgroundColor: "#CC0000",
  },
  "@media (orientation: portrait)":{
      backgroundColor: "hsla(352, 100%, 41%, .65)",
  },
},
div7: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: "0 auto",
    minWidth: "62%",
    maxHeight: "9vh",
    backgroundColor: "#D20808",
},
text: {
    color: "#4669F6",
    //fontSize: 102,
    fontFamily: "'Stalinist One', cursive",
    margin: "0 auto"
}
})

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/components/landing/landing.js